import React from "react";
import PageHeader from "../components/PageHeader";

export default function OtherGuidelines() {
  const breadcrumbs = [
    { label: "Home", link: "/" },
    { label: "Documents", link: "/documents" },
    { label: "Other Guidelines", active: true },
  ];

  const documents = [
    {
      title: "GUIDELINES ON CYBER SAFETY",
      size: "569.10 KB",
      date: "24-08-22",
      link: "#",
    },
    {
      title: "BEING SAFE ONLINE - GUIDELINE AND STANDARD CONTENT FOR RAISING AWARENESS AMONG CHILDREN, PARENTS, EDUCATORS, AND THE GENERAL PUBLIC",
      size: "4.12 MB",
      date: "24-08-22",
      link: "#",
    },
    {
      title: "GUIDELINES FOR PROTECTION OF CHILDREN IN SPORTS AUTHORITY OF INDIA (SAI ) TRAINING CENTRES",
      size: "141.93 KB",
      date: "11-07-22",
      link: "#",
    },
    {
      title: "GUIDELINES FOR CHILD YOGA",
      size: "1.58 MB",
      date: "11-07-22",
      link: "#",
    },
    {
      title: "COMPLAINT REDRESSAL MECHANISM FOR CHILD",
      size: "134.85 KB",
      date: "09-07-22",
      link: "#",
    },
    {
      title: "GUIDELINES FOR ESTABLISHMENT OF CHILD FRIENDLY POLICE STATIONS",
      size: "910.57 KB",
      date: "09-07-22",
      link: "#",
    },
    {
      title: "GUIDELINES FOR ORGANIZING CHILD FRIENDLY MELAS AND LARGE GATHERINGS",
      size: "2.07 MB",
      date: "09-07-22",
      link: "#",
    },
    {
      title: "GUIDELINES ON PINK TOILETS",
      size: "1.75 MB",
      date: "10-07-22",
      link: "#",
    },
  ];

  return (
    <div>
      {/* Page Header */}
      <PageHeader
        title="Other Guidelines (NCPCR, Govt. of India)"
        breadcrumbs={breadcrumbs}
      />

      {/* Timeline Section */}
      <section className="py-5 bg-light">
        <div className="container">
          <h2 className="text-primary fw-bold mb-5 text-center">
            Other Guidelines
          </h2>

          <div className="position-relative">
            {/* Center vertical line */}
            <div
              className="position-absolute top-0 start-50 translate-middle-x bg-primary"
              style={{ width: "4px", height: "100%", borderRadius: "2px" }}
            ></div>

            {/* Timeline items */}
            <div className="timeline position-relative">
              {documents.map((doc, index) => (
                <div
                  key={index}
                  className={`row g-0 mb-5 align-items-center ${
                    index % 2 === 0 ? "flex-row-reverse" : ""
                  }`}
                >
                  <div className="col-md-6 d-flex justify-content-center">
                    <div className="card shadow-sm p-4 rounded-4 border-0 timeline-card">
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <span className="badge bg-primary rounded-pill">
                          {index + 1}
                        </span>
                        <small className="text-muted">{doc.date}</small>
                      </div>
                      <h5 className="text-primary fw-bold mb-2">{doc.title}</h5>
                      <p className="text-secondary mb-3">{doc.size}</p>
                      <a
                        href={doc.link}
                        className="btn btn-outline-primary rounded-pill"
                      >
                        Details
                      </a>
                    </div>
                  </div>
                  <div className="col-md-6"></div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
